$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  let location_id = $('body').attr('event_id');
  let activeProductParameterGroup = '';

  if (p === 'organizer_event_ticket_category' && a === 'list') {
    $('select')
      .not('#event_ticket_category_table .product-more-parameter select')
      .select2({
        theme: 'bootstrap4',
        width: '100%',
      });
    function getProductParameterGroup(columnIndex) {
      if (columnIndex <= 6) return 'takeaway';
      if (columnIndex === 7) return 'production';
      if (columnIndex <= 10) return 'menu';
      if (columnIndex <= 12) return 'display';
      return 'extras';
    }

    function initializeProductParameterGroups() {
      $('#event_ticket_category_table tr').each(function () {
        $(this)
          .find('.product-more-parameter')
          .each(function (columnIndex) {
            $(this).attr(
              'data-parameter-group',
              getProductParameterGroup(columnIndex)
            );
          });
      });
    }

    function initializeVisibleProductParameterSelects() {
      const visibleSelects = $('#event_ticket_category_table select').filter(
        function () {
          const parameterCell = $(this).closest('.product-more-parameter');
          return (
            parameterCell.length === 0 || !parameterCell.hasClass('d-none')
          );
        }
      );
      visibleSelects
        .not('.select2-hidden-accessible, .product-printer-select')
        .select2({
          theme: 'bootstrap4',
          width: '100%',
        });
      visibleSelects.filter('.product-printer-select').selectpicker();
    }

    function getProductParameterGroupOption(parameterGroup) {
      return $('.product-parameter-group-option')
        .filter(function () {
          return (
            ($(this).attr('data-parameter-group') || '') === parameterGroup
          );
        })
        .first();
    }

    function updateMoreProductParametersVisibility() {
      initializeProductParameterGroups();
      $('.product-more-parameter').each(function () {
        const showParameter =
          activeProductParameterGroup !== '' &&
          $(this).attr('data-parameter-group') === activeProductParameterGroup;
        $(this).toggleClass('d-none', !showParameter);
      });
      const selectedOption = getProductParameterGroupOption(
        activeProductParameterGroup
      );
      $('.product-parameter-group-option').removeClass('active');
      selectedOption.addClass('active');
      const defaultLabel = $('#toggle-more-product-parameters').attr(
        'data-default-label'
      );
      $('#toggle-more-product-parameters span').text(
        activeProductParameterGroup
          ? `${defaultLabel}: ${selectedOption.attr('data-label')}`
          : defaultLabel
      );
      $('#toggle-more-product-parameters')
        .toggleClass('btn-primary', activeProductParameterGroup !== '')
        .toggleClass('btn-outline-primary', activeProductParameterGroup === '');
      initializeVisibleProductParameterSelects();
    }
    window.updateMoreProductParametersVisibility =
      updateMoreProductParametersVisibility;

    const initialProductParameterGroup =
      new URL(window.location.href).searchParams.get('parameter_group') || '';
    if (
      initialProductParameterGroup !== '' &&
      getProductParameterGroupOption(initialProductParameterGroup).length > 0
    ) {
      activeProductParameterGroup = initialProductParameterGroup;
      updateMoreProductParametersVisibility();
    }

    function updateTakeawayPriceInputs(row, values, enabled) {
      const priceFields = [
        'ticket_alter_price_ex_vat',
        'alter_degree_of_coverage',
        'alter_coverage_contribution',
        'alter_price_out_ex_mva',
        'alter_ticket_price_out_inc_mva',
      ];

      priceFields.forEach(function (fieldName) {
        const input = row.find(`[name='${fieldName}']`);
        const value = values?.[fieldName];
        input.val(
          enabled && value !== undefined && value !== null
            ? formattedPriceToShow(value)
            : ''
        );
      });

      const vatInput = row.find("[name='alter_vat_code']");
      if (enabled && values?.alter_vat_code !== undefined) {
        vatInput.val(String(values.alter_vat_code)).trigger('change.select2');
      }
      row.find('.product-takeaway-price-input').prop('disabled', !enabled);
    }

    function updateNormalPriceInputs(row, values) {
      if (values?.ticket_price_ex_vat === undefined) {
        return;
      }
      [
        'ticket_price_ex_vat',
        'degree_of_coverage',
        'coverage_contribution',
        'price_out_ex_mva',
        'ticket_price_out_inc_mva',
      ].forEach(function (fieldName) {
        row
          .find(`[name='${fieldName}']`)
          .val(formattedPriceToShow(values[fieldName]));
      });
    }

    function getTakeawayPriceInputValue(row, fieldName) {
      return (
        formattedValueForNumberInput(row.find(`[name='${fieldName}']`).val()) ||
        0
      );
    }

    $(document).on('click', '.product-parameter-group-option', function () {
      activeProductParameterGroup = $(this).attr('data-parameter-group') || '';
      updateMoreProductParametersVisibility();
      window.updateProductListParameterGroup(activeProductParameterGroup);
    });

    $(document).on('change', '.product-takeaway-toggle', function () {
      const toggle = $(this);
      const row = toggle.closest('tr');
      const productId = toggle.data('product-id');
      const takeawayEnabled = toggle.prop('checked');
      const blankTakeawayValues = {
        alter_vat_code: row.find("[name='mva']").val(),
      };
      if (!productId) {
        updateTakeawayPriceInputs(row, blankTakeawayValues, takeawayEnabled);
        return;
      }

      toggle.prop('disabled', true);
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_event_ticket_category/live_update_product',
        data: {
          product_id: productId,
          target: 'takeaway_enabled',
          update_value: takeawayEnabled ? 1 : 0,
        },
      })
        .done(function () {
          updateTakeawayPriceInputs(row, blankTakeawayValues, takeawayEnabled);
          popupAlert();
        })
        .fail(function (response) {
          toggle.prop('checked', !takeawayEnabled);
          const message = response.responseJSON?.error_message;
          alert(message || 'Something went wrong');
        })
        .always(function () {
          toggle.prop('disabled', false);
        });
    });

    $(document).on('change', '.product-takeaway-price-live-edit', function () {
      const input = $(this);
      const row = input.closest('tr');
      const inputValue = String(input.val()).replace(',', '.');
      if (isNaN(inputValue)) {
        return alert('Verdien må være et tall');
      }

      const takeawayInputs = row.find('.product-takeaway-price-input');
      takeawayInputs.prop('disabled', true);
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_event_ticket_category/live_update_product',
        data: {
          product_id: row.attr('data-event-ticket-category-id'),
          target: input.attr('name'),
          update_value: inputValue,
        },
      })
        .done(function (data) {
          updateTakeawayPriceInputs(row, data, true);
          popupAlert();
        })
        .fail(function (response) {
          const message = response.responseJSON?.error_message;
          alert(message || 'Something went wrong');
        })
        .always(function () {
          takeawayInputs.prop('disabled', false);
        });
    });

    $(document).on(
      'keydown',
      '.product-takeaway-price-input',
      function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          $(this).blur();
        }
      }
    );

    $(document).on('change', '.product-takeaway-price-new', function () {
      const input = $(this);
      const row = input.closest('tr');
      const fieldName = input.attr('name');
      const fieldValue = String(input.val()).replace(',', '.');
      if (isNaN(fieldValue)) {
        return alert('Verdien må være et tall');
      }

      const vatInput = row.find("[name='alter_vat_code']");
      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/calculate-alter-price',
        data: {
          field: fieldName === 'alter_vat_code' ? 'alter_mva' : fieldName,
          alterProductPrice: getTakeawayPriceInputValue(
            row,
            'ticket_alter_price_ex_vat'
          ),
          alterDegreeOfCoverage: getTakeawayPriceInputValue(
            row,
            'alter_degree_of_coverage'
          ),
          alterCoverageOfContribution: getTakeawayPriceInputValue(
            row,
            'alter_coverage_contribution'
          ),
          alterPriceOutExMva: getTakeawayPriceInputValue(
            row,
            'alter_price_out_ex_mva'
          ),
          alterMva: Number(vatInput.find('option:selected').text()),
          alterPriceOutIncMva: getTakeawayPriceInputValue(
            row,
            'alter_ticket_price_out_inc_mva'
          ),
        },
      }).done(function (data) {
        updateTakeawayPriceInputs(
          row,
          {
            ticket_alter_price_ex_vat: data.alterProductPrice,
            alter_degree_of_coverage: data.alterDegreeOfCoverage,
            alter_coverage_contribution: data.alterCoverageOfContribution,
            alter_price_out_ex_mva: data.alterPriceOutExMva,
            alter_vat_code: vatInput.val(),
            alter_ticket_price_out_inc_mva: data.alterPriceOutIncMva,
          },
          true
        );
      });
    });

    $(document).on('show.bs.select', '.product-printer-live-edit', function () {
      $(this).data('initial-printer-ids', ($(this).val() || []).join(','));
    });

    $(document).on('hidden.bs.select', '.product-printer-live-edit', function () {
      const select = $(this);
      const printerIds = select.val() || [];
      if (printerIds.join(',') === select.data('initial-printer-ids')) {
        return;
      }
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_event_ticket_category/live_update_product',
        data: {
          product_id: select
            .closest('tr')
            .attr('data-event-ticket-category-id'),
          target: 'printer_ids',
          printer_ids: printerIds,
        },
      })
        .done(function () {
          popupAlert();
        })
        .fail(function (response) {
          const message = response.responseJSON?.error_message;
          alert(message || 'Something went wrong');
        });
    });

    // select2 removes the last tag on Backspace in an empty search field and auto-saves it; extras are removed via the tag's × only.
    document.addEventListener(
      'keydown',
      function (event) {
        const searchField = $(event.target);
        if (
          !['Backspace', 'Delete'].includes(event.key) ||
          !searchField.is('.select2-search__field') ||
          searchField.val() !== ''
        ) {
          return;
        }
        const select = searchField.closest('.select2-container').prev('select');
        if (select.is('.product-extra-live-edit, .product-extra-new')) {
          event.stopPropagation();
        }
      },
      true
    );

    $(document).on('change', '.product-extra-live-edit', function () {
      const select = $(this);
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_event_ticket_category/live_update_product',
        data: {
          product_id: select
            .closest('tr')
            .attr('data-event-ticket-category-id'),
          target: 'extra_product_ids',
          extra_product_ids: select.val() || [],
        },
      })
        .done(function () {
          popupAlert();
        })
        .fail(function (response) {
          const message = response.responseJSON?.error_message;
          alert(message || 'Something went wrong');
        });
    });

    $(document).on('change', '.product-menu-toggle', function () {
      const toggle = $(this);
      const row = toggle.closest('tr');
      const productId = toggle.data('product-id');
      const menuProductEnabled = toggle.prop('checked');
      const totalSumToggle = row.find('.product-total-sum-toggle');
      const menuProductSelect = row.find(
        '.product-menu-products-live-edit, .product-menu-products-new'
      );
      const previousTotalSum = totalSumToggle.prop('checked');
      const previousMenuProductIds = menuProductSelect.val() || [];

      totalSumToggle.prop('disabled', !menuProductEnabled);
      menuProductSelect.prop('disabled', !menuProductEnabled);
      if (!menuProductEnabled) {
        totalSumToggle.prop('checked', false);
        menuProductSelect.val(null).trigger('change.select2');
      }
      if (!productId) {
        return;
      }

      toggle.prop('disabled', true);
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_event_ticket_category/live_update_product',
        data: {
          product_id: productId,
          target: 'menu_product_enabled',
          update_value: menuProductEnabled ? 1 : 0,
          is_product_total_sum: totalSumToggle.prop('checked') ? 1 : 0,
        },
      })
        .done(function (data) {
          updateNormalPriceInputs(row, data);
          popupAlert();
        })
        .fail(function (response) {
          toggle.prop('checked', !menuProductEnabled);
          totalSumToggle.prop('disabled', menuProductEnabled);
          totalSumToggle.prop('checked', previousTotalSum);
          menuProductSelect.prop('disabled', menuProductEnabled);
          menuProductSelect
            .val(previousMenuProductIds)
            .trigger('change.select2');
          alert(response.responseJSON?.error_message || 'Something went wrong');
        })
        .always(function () {
          toggle.prop('disabled', false);
        });
    });

    $(document).on('change', '.product-total-sum-toggle', function () {
      const toggle = $(this);
      const productId = toggle.data('product-id');
      if (!productId) {
        return;
      }
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_event_ticket_category/live_update_product',
        data: {
          product_id: productId,
          target: 'is_product_total_sum',
          update_value: toggle.prop('checked') ? 1 : 0,
        },
      })
        .done(function (data) {
          updateNormalPriceInputs(toggle.closest('tr'), data);
          popupAlert();
        })
        .fail(function (response) {
          toggle.prop('checked', !toggle.prop('checked'));
          alert(response.responseJSON?.error_message || 'Something went wrong');
        });
    });

    $(document).on('change', '.product-menu-products-live-edit', function () {
      const select = $(this);
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_event_ticket_category/live_update_product',
        data: {
          product_id: select
            .closest('tr')
            .attr('data-event-ticket-category-id'),
          target: 'menu_product_ids',
          menu_product_ids: select.val() || [],
        },
      })
        .done(function (data) {
          updateNormalPriceInputs(select.closest('tr'), data);
          popupAlert();
        })
        .fail(function (response) {
          alert(response.responseJSON?.error_message || 'Something went wrong');
        });
    });

    $(document).on(
      'change',
      '.product-category-pos-live-edit, .product-category-self-service-live-edit',
      function () {
        const select = $(this);
        const target = select.hasClass('product-category-pos-live-edit')
          ? 'product_category_pos_ids'
          : 'product_category_self_service_ids';
        $.ajax({
          type: 'POST',
          url: '/ajax/organizer_event_ticket_category/live_update_product',
          data: {
            product_id: select
              .closest('tr')
              .attr('data-event-ticket-category-id'),
            target,
            category_ids: select.val() || [],
          },
        })
          .done(function () {
            popupAlert();
          })
          .fail(function (response) {
            alert(
              response.responseJSON?.error_message || 'Something went wrong'
            );
          });
      }
    );

    $(document).on('change', '#product-live-edit', function (e) {
      e.preventDefault();

      let live_edit = 0;
      let search_string = $('#search_string').val();
      let product_type = $('#product_type').val();
      let supplier_id = $('#sort').data('supplier-id') ?? '';
      let page = $('#event_ticket_category_table').attr('data-page');
      let isLiveEdit = $(this).prop('checked');

      if (isLiveEdit) {
        live_edit = 1;
      } else {
        live_edit = 0;
      }
      let formData = new FormData();
      formData.append('live_edit', live_edit);
      formData.append('search_string', search_string);
      formData.append('location_id', location_id);
      formData.append('product_type', product_type);
      formData.append('supplier_id', supplier_id);
      formData.append(
        'product_group_unique_id',
        $('#product_group_unique_id').val() || ''
      );
      formData.append('top_product_group', $('#top-product-group').val() || '');
      formData.append(
        'selected_location_id',
        $('#selected_location_id').val() || ''
      );
      formData.append('page', page);
      formData.append('status', 1);

      getProductList(formData);
    });

    $(document).on('click', '.delete-live-edit-new-product', function (e) {
      $(this).closest('tr').fadeOut(300);
      $('.add-new-live-edit-product').removeClass('d-none');
      $('.add-new-live-edit-product').addClass('d-flex');
      $('html, body').animate({ scrollTop: $(document).height() }, 400);
      setTimeout(() => {
        $(this).closest('tr').remove();
      }, 400);
    });

    $(document).on('click', '#live-edit-new-product-btn', function (e) {
      const liveEditNewProductCount = $('.event-ticket-category-new').length;
      getLiveEditNewProduct({
        location_id,
        new_product_count: liveEditNewProductCount,
      });
    });

    $(document).on('click', '#live-edit-clone-new-product-btn', function (e) {
      const productId = $(this).attr('data-product-id');
      const liveEditNewProductCount = $('.event-ticket-category-new').length;
      getLiveEditNewProduct({
        location_id,
        product_id: productId,
        new_product_count: liveEditNewProductCount,
      });
    });

    $(document).on('click', '.save-new-live-edit-product', function (e) {
      const row = $(this).closest('tr');
      const nameInput = row.find("input[name='name']");
      const ticketPriceInput = row.find("input[name='ticket_price_ex_vat']");

      if (nameInput.val() === '') {
        return alert('Vennligst oppgi produktnavn');
      }
      if (ticketPriceInput.val() === '') {
        // return alert("Vennligst oppgi billettpris");
        ticketPriceInput.val(0);
      }

      const inputs = row.find('input, select');
      const formdata = new FormData();

      inputs.each(function () {
        const input = $(this)[0];
        if (input.name && input.tagName === 'SELECT' && input.multiple) {
          const selectedValues = $(input).val() || [''];
          selectedValues.forEach(function (value) {
            formdata.append(input.name, value);
          });
        } else if (input.name && (input.type !== 'checkbox' || input.checked)) {
          formdata.append(
            input.name,
            input.files ? input.files[0] : input.value
          );
        }
      });
      formdata.append('location_id', location_id);

      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');
      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');
      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/save-live-edit-new-product',
        data: formdata,
        enctype: 'multipart/form-data',
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (data) {
            popupAlert();
            updateNormalPriceInputs(row, data);
            row.attr('id', `event-ticket-category-id-${data.product_id}`);
            row.attr('data-event-ticket-category-id', data.product_id);
            row.find('input, select').addClass('product-live-edit');
            row
              .find('.product-takeaway-price-new')
              .removeClass('product-takeaway-price-new')
              .addClass('product-takeaway-price-live-edit');
            row
              .find('.product-printer-new')
              .removeClass('product-printer-new')
              .addClass('product-printer-live-edit');
            row
              .find('.product-extra-new')
              .removeClass('product-extra-new')
              .removeClass('product-live-edit')
              .attr('name', 'extra_product_ids[]')
              .addClass('product-extra-live-edit');
            row
              .find('.product-menu-products-new')
              .removeClass('product-menu-products-new product-live-edit')
              .addClass('product-menu-products-live-edit');
            row
              .find('.product-category-pos-new')
              .removeClass('product-category-pos-new product-live-edit')
              .attr('name', 'product_category_pos_ids[]')
              .addClass('product-category-pos-live-edit');
            row
              .find('.product-category-self-service-new')
              .removeClass(
                'product-category-self-service-new product-live-edit'
              )
              .attr('name', 'product_category_self_service_ids[]')
              .addClass('product-category-self-service-live-edit');
            row
              .find('.product-takeaway-toggle')
              .attr('data-product-id', data.product_id)
              .data('product-id', data.product_id);
            row
              .find('.product-menu-toggle, .product-total-sum-toggle')
              .removeClass('product-live-edit')
              .attr('data-product-id', data.product_id)
              .data('product-id', data.product_id);
            row
              .find('.mva-selector')
              .attr('data-previous-vat-code', function () {
                return $(this).val();
              });
            $('#live-edit-new-product-action').remove();
            $('.live-edit-action-for-saved-product').removeClass('d-none');
            $('.event-ticket-category-new').removeAttr('style');
            $('.add-new-live-edit-product').removeClass('d-none');
            const skuInput = row.find("input[name='sku']");
            skuInput.prop('disabled', true);

            const deleteBtn = row.find('.event-ticket-category-delete');
            const deactivateBtn = row.find('.event-ticket-category-unpublish');

            deleteBtn.attr('data-delete-id', data.product_id);
            deactivateBtn.attr(
              'data-event-ticket-category-id',
              data.product_id
            );
            $('.add-new-live-edit-product').addClass('d-flex');
            $('html, body').animate({ scrollTop: row.offset().top }, 100);
          }
        })
        .fail(function (data) {
          if (data.responseText) {
            disabledOnClick.prop('disabled', false);
            disabledOnClick.html('Lagre');

            let responseJson;
            try {
              responseJson = JSON.parse(data.responseText);
            } catch (e) {
              responseJson = null;
            }

            if (responseJson && responseJson.error_message) {
              alert(responseJson.error_message);
            } else {
              alert('Something went wrong');
            }
          }
        });
    });
    $(document).on(
      'change',
      '.mva-selector.product-live-edit',
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const select = $(this);
        const previousVatCode = String(select.attr('data-previous-vat-code'));
        const selectedVatCode = String(select.val());
        const row = select.closest('tr');
        const productId = row.attr('data-event-ticket-category-id');

        window.chooseProductVatUpdateMode().then(function (vatUpdateMode) {
          if (!vatUpdateMode) {
            select.val(previousVatCode).trigger('change.select2');
            return;
          }

          select.prop('disabled', true);
          $.ajax({
            type: 'POST',
            url: '/ajax/organizer_event_ticket_category/live_update_product',
            data: {
              product_id: productId,
              target: 'vat_code_with_mode',
              vat_code: selectedVatCode,
              vat_update_mode: vatUpdateMode,
            },
          })
            .done(function (data) {
              updateNormalPriceInputs(row, data);
              select.attr('data-previous-vat-code', data.vat_code);
              popupAlert();
            })
            .fail(function (response) {
              select.val(previousVatCode).trigger('change.select2');
              alert(
                response.responseJSON?.error_message || 'Something went wrong'
              );
            })
            .always(function () {
              select.prop('disabled', false);
            });
        });
      }
    );

    //update product

    $(document).on(
      'input',
      'input.product-live-edit:not([name="name"]):not([name="sku"]), input.live-edit-new-product',
      function () {
        sanitizeDecimalInputElement(this);
      }
    );

    $(document).on('change', '.product-live-edit', function (e) {
      if (
        $(this).hasClass('product-takeaway-toggle') ||
        $(this).hasClass('product-takeaway-price-input') ||
        $(this).hasClass('product-printer-live-edit') ||
        $(this).hasClass('product-extra-live-edit') ||
        $(this).hasClass('product-menu-toggle') ||
        $(this).hasClass('product-total-sum-toggle') ||
        $(this).hasClass('product-menu-products-live-edit') ||
        $(this).hasClass('product-category-pos-live-edit') ||
        $(this).hasClass('product-category-self-service-live-edit') ||
        $(this).hasClass('mva-selector')
      ) {
        return;
      }
      let productId = $(this)
        .closest('tr')
        .attr('data-event-ticket-category-id');
      let columnToUpdate = $(this).attr('name');
      let inputedValue = $(this).val().replace(',', '.');

      let formData = new FormData();
      formData.append('product_id', productId);
      let url = '';
      let updateValue = null;

      formData.append('product_id', productId);
      formData.append('target', columnToUpdate);
      if (
        columnToUpdate === 'name' ||
        columnToUpdate === 'supplier_id' ||
        columnToUpdate == 'product_group_unique_id' ||
        columnToUpdate == 'sku'
      ) {
        updateValue = $(this).val();
        url = '/ajax/organizer_event_ticket_category/live_update_product';

        formData.append('update_value', updateValue);
      } else {
        if (isNaN(inputedValue)) {
          return alert('Verdien må være et tall');
        }
        updateValue = formattedValueForNumberInput(inputedValue);
        url =
          '/ajax/organizer_event_ticket_category/live_update_product_price_group';

        formData.append('update_value', updateValue);
      }
      updateProdcutPriceList(columnToUpdate, updateValue, productId);
      productLiveUpdate(formData, url);
    });

    $(document).on('change', '.live-edit-new-product', function (e) {
      let productId = $(this)
        .closest('tr')
        .attr('data-event-ticket-category-id');
      let columnToUpdate = $(this).attr('name');
      let inputedValue = $(this).val().replace(',', '.');
      let updateValue = formattedValueForNumberInput(inputedValue);
      updateProdcutPriceList(columnToUpdate, updateValue, productId);
    });

    $(document).on('change', '.edit-product-image', function (event) {
      const input = event.target;
      const container = input.parentElement;
      const productId = input.getAttribute('data-product-id');

      if (!productId) {
        return;
      }

      $(container).find('.spinner').css('display', 'flex');

      const reader = new FileReader();

      reader.onload = function () {
        const img = container.querySelector('img');
        const imageData = reader.result;

        if (img) {
          img.src = imageData;
        } else {
          const imageTag = document.createElement('img');
          const thumbnail = document.getElementById('thumbnail');
          imageTag.style = 'max-height: 50px; width:auto';

          imageTag.src = imageData;
          container.removeChild(thumbnail);
          container.append(imageTag);
        }
      };

      reader.readAsDataURL(input.files[0]);

      const formData = new FormData();
      formData.append('picture', input.files[0]);
      formData.append('event_id', location_id);
      formData.append('event_ticket_category_id', productId);

      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_event_ticket_category/update_image',
        data: formData,
        enctype: 'multipart/form-data',
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          $('.spinner').hide();

          if (data.html) {
            $(`label[for="edit-product-image-${productId}"]`)
              .find('i')
              .remove();
            $(`label[for="edit-product-image-${productId}"]`)
              .find('img')
              .remove();
            $(`#edit-product-image-${productId}`).before(data.html);
          }
        })
        .fail(function (data) {
          $('.spinner').hide();
        });
    });

    function updateProdcutPriceList(columnToUpdate, updateValue, productId) {
      let product_price = parseInt($(`#product-price-${productId}`).val());
      let selectedMva = $(`#product-mva-${productId}`)
        .find('option:selected')
        .text();
      let mva = parseInt(selectedMva);
      if (columnToUpdate === 'degree_of_coverage') {
        if (!product_price && !mva) {
          return;
        }
        let degree_of_coverage = updateValue;
        let price_out_ex_mva =
          parseFloat(product_price) * parseFloat(degree_of_coverage);
        let coverage_contribution = price_out_ex_mva - product_price;
        let ticket_price_out_inc_mva = price_out_ex_mva * (1 + mva / 100);

        $(this).val(formattedPriceToShow(updateValue));
        $(`#coverage-contribution-${productId}`).val(
          formattedPriceToShow(coverage_contribution)
        );
        $(`#ticket-price-out-ex-mva-${productId}`).val(
          formattedPriceToShow(price_out_ex_mva)
        );
        $(`#ticket-price-out-inc-mva-${productId}`).val(
          formattedPriceToShow(ticket_price_out_inc_mva)
        );
      } else if (columnToUpdate === 'coverage_contribution') {
        let coverage_contribution = updateValue;
        let price_out_ex_mva = coverage_contribution + product_price;
        let degree_of_coverage =
          product_price == 0 ? 0 : price_out_ex_mva / product_price;
        let ticket_price_out_inc_mva = price_out_ex_mva * (1 + mva / 100);

        $(this).val(formattedPriceToShow(updateValue));
        $(`#degree-of-coverage-${productId}`).val(
          formattedPriceToShow(degree_of_coverage)
        );
        $(`#ticket-price-out-ex-mva-${productId}`).val(
          formattedPriceToShow(price_out_ex_mva)
        );
        $(`#ticket-price-out-inc-mva-${productId}`).val(
          formattedPriceToShow(ticket_price_out_inc_mva)
        );
      } else if (columnToUpdate === 'price_out_ex_mva') {
        let price_out_ex_mva = updateValue;
        let coverage_contribution =
          parseFloat(price_out_ex_mva) - parseFloat(product_price);

        let degree_of_coverage =
          product_price == 0 ? 0 : price_out_ex_mva / product_price;
        let ticket_price_out_inc_mva = formattedValueForNumberInput(
          price_out_ex_mva * (1 + mva / 100)
        );
        $(this).val(formattedPriceToShow(updateValue));
        $(`#coverage-contribution-${productId}`).val(
          formattedPriceToShow(coverage_contribution)
        );
        $(`#degree-of-coverage-${productId}`).val(
          formattedPriceToShow(degree_of_coverage)
        );
        $(`#ticket-price-out-inc-mva-${productId}`).val(
          formattedPriceToShow(ticket_price_out_inc_mva)
        );
      } else if (columnToUpdate === 'mva') {
        let vatCodeNoOutputVat = $('#vat-code-group').attr(
          'data-vat-code-no-output-vat'
        );
        let vatCodeOutputVatFood = $('#vat-code-group').attr(
          'data-vat-code-output-vat-food'
        );
        let vatCodeOutputVatReducedRate = $('#vat-code-group').attr(
          'data-vat-code-output-vat-reduced-rate'
        );
        let vatCodeNoOutputVatPercent = $('#vat-percent-group').attr(
          'data-vat-code-no-output-vat-percent'
        );
        let vatCodeOutputVatFoodPercent = $('#vat-percent-group').attr(
          'data-vat-code-output-vat-food-percent'
        );
        let vatCodeOutputVatReducedRatePercent = $('#vat-percent-group').attr(
          'data-vat-code-output-vat-reduced-rate-percent'
        );
        let vatCodeOutputVatRegularRatePercent = $('#vat-percent-group').attr(
          'data-vat-code-output-vat-regular-rate-percent'
        );

        if (updateValue == vatCodeNoOutputVat) {
          mva = vatCodeNoOutputVatPercent;
        } else if (updateValue == vatCodeOutputVatFood) {
          mva = vatCodeOutputVatFoodPercent;
        } else if (updateValue == vatCodeOutputVatReducedRate) {
          mva = vatCodeOutputVatReducedRatePercent;
        } else {
          mva = vatCodeOutputVatRegularRatePercent;
        }
        let coverage_contribution = $(
          `#coverage-contribution-${productId}`
        ).val();
        let degree_of_coverage = $(`#degree-of-coverage-${productId}`).val();
        let price_out_ex_mva = $(`#ticket-price-out-ex-mva-${productId}`).val();

        let ticket_price_out_inc_mva =
          parseFloat(price_out_ex_mva) * (1 + parseInt(mva) / 100);

        $(`#ticket-price-out-inc-mva-${productId}`).val(
          formattedPriceToShow(ticket_price_out_inc_mva)
        );
      } else if (columnToUpdate === 'ticket_price_ex_vat') {
        let coverage_contribution = $(
          `#coverage-contribution-${productId}`
        ).val();
        let degree_of_coverage = $(`#degree-of-coverage-${productId}`).val();
        let price_out_ex_mva = $(`#ticket-price-out-ex-mva-${productId}`).val();

        product_price = parseFloat(updateValue);
        price_out_ex_mva = formattedValueForNumberInput(
          parseFloat(product_price) * parseFloat(degree_of_coverage)
        );
        coverage_contribution = price_out_ex_mva - product_price;
        let ticket_price_out_inc_mva = price_out_ex_mva * (1 + mva / 100);

        $(`#coverage-contribution-${productId}`).val(
          formattedPriceToShow(coverage_contribution)
        );
        $(`#ticket-price-out-ex-mva-${productId}`).val(
          formattedPriceToShow(price_out_ex_mva)
        );
        $(`#ticket-price-out-inc-mva-${productId}`).val(
          formattedPriceToShow(ticket_price_out_inc_mva)
        );
      } else if (columnToUpdate === 'ticket_price_out_inc_mva') {
        let ticket_price_out_inc_mva = updateValue;
        let price_out_ex_mva = ticket_price_out_inc_mva / (1 + mva / 100);

        let coverage_contribution = price_out_ex_mva - product_price;

        let degree_of_coverage =
          product_price == 0 ? 0 : price_out_ex_mva / product_price;
        $(this).val(formattedPriceToShow(updateValue));
        $(`#ticket-price-out-ex-mva-${productId}`).val(
          formattedPriceToShow(price_out_ex_mva)
        );
        $(`#coverage-contribution-${productId}`).val(
          formattedPriceToShow(coverage_contribution)
        );
        $(`#degree-of-coverage-${productId}`).val(
          formattedPriceToShow(degree_of_coverage)
        );
      }
    }

    function productLiveUpdate(formData, url) {
      $.ajax({
        type: 'POST',
        url,
        data: formData,
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          popupAlert();
          return true;
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    function getProductList(formData) {
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_event_ticket_category/search',
        data: formData,
        enctype: 'multipart/form-data',
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $('#product-list').empty();
            $('#product-list').append(data.html);
            updateMoreProductParametersVisibility();
            window.updateProductListSearchParams(
              Object.fromEntries(formData.entries())
            );
          }

          $('html,body').scrollTop(0);
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    function getLiveEditNewProduct(data = {}) {
      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/live-edit-new-product-row',
        data: data,
      })
        .done(function (data) {
          if (
            data.html !== undefined &&
            data.html !== null &&
            data.html !== ''
          ) {
            $('#event_ticket_category_table tbody').append(data.html);
            updateMoreProductParametersVisibility();
            $('#event_ticket_category_table tbody tr:last select')
              .not('.product-printer-select')
              .select2({
                theme: 'bootstrap4',
              });
            const liveEditNewProductCount = $(
              '.event-ticket-category-new'
            ).length;
            if (liveEditNewProductCount > 0) {
              $('.add-new-live-edit-product').removeClass('d-flex');
              $('.add-new-live-edit-product').addClass('d-none');
            }
          }
        })
        .fail(function (data) {
          if (data.responseJSON.error_message) {
            alert(data.responseJSON.error_message);
            return;
          }

          if (data.error) {
            return alert(data.error);
          }
        });
    }
  }
});
